import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import LocationMap from "../../components/contact/LocationMap";
import { useToasts } from "react-toast-notifications";
import { sendMail } from "../../helpers/dbOperations";

const Contact = ({ location }) => {

  const { pathname } = location;
  const { addToast } = useToasts();

  const [Name, setfName] = useState();
  const [Mail, setfMail] = useState();
  const [Oggetto, setfObject] = useState();
  const [Message, setfMessage] = useState();

  const handleSubmit = async e => {
    var ElementiInseriti = VerificaCampiObbligatori();

    e.preventDefault();

    //Verifico i Campi Obbligatori
    VerificaCampiObbligatori();

    /*username
      password
      Nome
      EMail
      Oggetto
      Messaggio
      */

    var username = "";
    var password = "";
    var Nome = Name;
    var EMail = Mail;
    var Messaggio = Message;

    if (ElementiInseriti) {
      var ritorno = await sendMail({ username, password, Nome, EMail, Oggetto, Messaggio });

      if (ritorno == undefined || ritorno.Errrore != "") {
        addToast("Messaggio Inviato Correttamente", { appearance: "success", autoDismiss: true, placement: 'bottom-left' });
      }
      else {
        addToast("Problema nell'Invio del Messaggio", { appearance: "error", autoDismiss: true, placement: 'bottom-left' });
      }

      setfName("");
      setfMail("");
      setfObject("");
      setfMessage("");
    }
    else
      addToast("Attenzione, campi obbligatori non inseriti", { appearance: "error", autoDismiss: true, placement: 'bottom-left' });
  }

  function VerificaCampiObbligatori() {
    var valore;
    var sValFinale;

    var ElementiInseriti = true;

    var Elemento;

    Elemento = document.querySelector('[nomeField="' + "name" + '"]');
    valore = Elemento.value;
    setfName(valore);
    sValFinale = { "Nome": valore };

    Elemento = document.querySelector('[nomeField="' + "mail" + '"]');
    valore = Elemento.value;
    setfMail(valore);

    Elemento = document.querySelector('[nomeField="' + "object" + '"]');
    valore = Elemento.value;
    setfObject(valore);

    Elemento = document.querySelector('[nomeField="' + "message" + '"]');
    valore = Elemento.value;
    setfMessage(valore);

    var elements = document.querySelectorAll('[requiredField="' + "1" + '"]');
    for (var ii = 0; ii < elements.length; ii++) {
      valore = elements[ii].value;
      if (valore == "") {
        ElementiInseriti = false;
        elements[ii].style.border = "thin dotted red";
      }
      else {
        elements[ii].style.border = "thin dotted black";
      }
    }

    return ElementiInseriti;
  }

  return (
    <Fragment>
      <MetaTags>
        <title>DGA Planet Shirt SRL | Contact</title>
        <meta
          name="description"
          content="powered by Pegaso Gest Team"
        />
      </MetaTags>

      <LayoutOne>
        {/* breadcrumb */}

        <div className="contact-area pb-100 pt-20">
          <div className="container">
            <div className="contact-map mb-10">
              <h2>I nostri uffici</h2>
              <LocationMap latitude="40.74579" longitude="14.52783" />
            </div>
            <div className="custom-row-2">
              <div className="col-lg-4 col-md-5">
                <div className="contact-info-wrap">
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i className="fa fa-phone" />
                    </div>
                    <div className="contact-info-dec">
                      <p>(+39) 081 8796566</p>
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i class="fa fa-whatsapp" />
                    </div>
                    <div className="contact-info-dec">
                      <p><a href="https://wa.me/message/JYR7V2243NSEN1">+390818796566</a></p>
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i class="fa fa-facebook" />
                    </div>
                    <div className="contact-info-dec">
                      <p><a href="https://www.facebook.com/profile.php?id=100090985004006">Dga Planet-shirt</a></p>
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i class="fa fa-instagram" />
                    </div>
                    <div className="contact-info-dec">
                      <p><a href="https://instagram.com/dgaplanetshirt?igshid=ZDdkNTZiNTM=">dgaplanetshirt</a></p>
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i className="fa fa-globe" />
                    </div>
                    <div className="contact-info-dec">
                      <p>
                        <a href="mailto:info@dgaplanetshirt.com">info@dgaplanetshirt.com</a>
                      </p>
                      <p>
                        <a href="http://www.dgaplanetshirt.com">dgaplanetshirt.com</a>
                      </p>
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i className="fa fa-map-marker" />
                    </div>
                    <div className="contact-info-dec">
                      <p>Via S. Antonio Abate  Trav. F. Morlicchio di Scafati</p>
                      <p>84018 Scafati (SA) Italy</p>
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i class="fa fa-clock-o" />
                    </div>
                    <div className="contact-info-dec">
                      <p>Lunedì/Venerdì</p>
                      <p>09:00 - 12.30<br /> 15:00 - 17:30</p>
                    </div>
                  </div>

                  {/*<div className="contact-social text-center">
                    <h3>Seguici</h3>
                    <ul>
                      <li>
                        <a href="//facebook.com">
                          <i className="fa fa-facebook" />
                        </a>
                      </li>
                      <li>
                        <a href="//pinterest.com">
                          <i className="fa fa-pinterest-p" />
                        </a>
                      </li>
                      <li>
                        <a href="//thumblr.com">
                          <i className="fa fa-tumblr" />
                        </a>
                      </li>
                      <li>
                        <a href="//vimeo.com">
                          <i className="fa fa-vimeo" />
                        </a>
                      </li>
                      <li>
                        <a href="//twitter.com">
                          <i className="fa fa-twitter" />
                        </a>
                      </li>
                    </ul>
  </div>*/}
                </div>
              </div>
              <div className="col-lg-8 col-md-7">
                <div className="contact-form">
                  <div className="contact-title mb-30">
                    <h2>Entra in contatto con noi</h2>
                  </div>
                  <form className="contact-form-style" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6">
                        <input nomeField="name"
                          value={Name}
                          onChange={VerificaCampiObbligatori}
                          requiredField="1"
                          name="Nome"
                          placeholder="Nome*"
                          type="text" />
                      </div>
                      <div className="col-lg-6">
                        <input nomeField="mail"
                          onChange={VerificaCampiObbligatori}
                          value={Mail}
                          requiredField="1"
                          name="email"
                          placeholder="Email*"
                          type="email" />
                      </div>
                      <div className="col-lg-12">
                        <input
                          nomeField="object"
                          requiredField="1"
                          name="Oggetto"
                          placeholder="Oggetto*"
                          type="text"
                          value={Oggetto}
                          onChange={VerificaCampiObbligatori}
                        />
                      </div>
                      <div className="col-lg-12">
                        <textarea
                          nomeField="message"
                          onChange={VerificaCampiObbligatori}
                          requiredField="1"
                          name="messaggio"
                          placeholder="Scrivi qui il tuo messaggio*"
                          defaultValue={""}
                          value={Message}
                        />
                        <button className="submit" type="submit">
                          INVIA
                        </button>
                      </div>
                    </div>
                  </form>
                  <p className="form-messege" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

Contact.propTypes = {
  location: PropTypes.object
};

export default Contact;
